import React, { ReactElement } from 'react';
import { createUseStyles } from 'react-jss';
import { MessageBar, MessageBarType as NotificationType } from '@fluentui/react';

export { NotificationType };

type Notification = {
  message: string | ReactElement,
  type: NotificationType,
};

const NotificationApiContext = React.createContext<{
  showNotification:(message: string | ReactElement, type: NotificationType, timeout?: number) => void,
}>({
      showNotification: () => { },
    });

export const useNotificationApi = () => React.useContext(NotificationApiContext);

const useStyles = createUseStyles(() => ({
  messageBar: {
    position: 'fixed',
    bottom: '15vh',
    width: '30vw',
    left: '35vw',
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'left',
    padding: '8px',
  },
}));

const defaultNotificationTimeout: number = 3000;

export const NotificationContainer: React.FunctionComponent<React.PropsWithChildren> = (props) => {
  const classes = useStyles();
  const [notification, setNotification] = React.useState<Notification>();
  const promiseRef = React.useRef<Promise<void>>(Promise.resolve());

  const showNotification = React.useCallback((message: string | ReactElement, type: NotificationType, timeout?: number) => {
    promiseRef.current = promiseRef.current.then(() => new Promise<void>((resolve) => {
      setNotification({
        message,
        type,
      });

      setTimeout(() => {
        setNotification(undefined);
        resolve();
      }, timeout ?? defaultNotificationTimeout);
    }));
  }, [setNotification]);

  const { children } = props;
  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <NotificationApiContext.Provider value={{ showNotification }}>
      {children}
      {
            notification && (
            <MessageBar
              messageBarType={notification.type}
              className={classes.messageBar}
            >
              {notification.message}
            </MessageBar>
            )
        }
    </NotificationApiContext.Provider>
  );
};
